import { QueryClient } from "react-query";
import { store } from "../store";
import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import { SessionInvalidatedError } from "@funded-here-interface/common/src/Utils/axiosSessionInterceptor";
import { isSessionInvalidationInProgress } from "@funded-here-interface/common/src/Utils/sessionState";
import { RefreshCooldownError } from "@funded-here-interface/common/src/hooks/useRefreshAuth";

const handleOnError = (message: string) => {
  if (message === "Unauthorized") {
    // If the session interceptor or WebSocket is already handling invalidation,
    // don't do a competing redirect — it would race with the overlay
    if (isSessionInvalidationInProgress()) return;

    store.dispatch(resetAuthState());
    sessionStorage.setItem("sessionExpired", "true");
    window.location.replace("/login");

    return;
  }
};

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
    queries: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
  },
});

export { client };
